<template>
  <div class="markdown-display-box">
    <div v-if="isLoading" class="loading-indicator">正在加载分析结果...</div>
    <div v-if="error" class="error-message">{{ error }}</div>

    <div class="markdown-content" v-html="renderedHtml"></div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it';
import {fetchAnalysisResultApi} from '@/api/file_llm_analyse';

export default {
  name: 'MarkdownDisplay',
  props: {
    file_info: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      md: new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
      }),
      rawMarkdownResponse: "",
      isLoading: false,
      error: null,
      initialDataLoaded: false, // 用于区分初始无数据和加载后无数据
      streamCancellation: null, // 用于存储从 API 返回的 cancelStream 函数
    };
  },
  computed: {
    renderedHtml() {
      if (this.rawMarkdownResponse) {
        return this.md.render(this.rawMarkdownResponse);
      }
      return "";
    }
  },
  methods: {
    renderInitialMarkdown() {
      // todo mock data
      this.file_info.file_analyse = "测试ai数据"
      if (this.file_info.file_analyse) {
        this.rawMarkdownResponse = this.file_info.file_analyse.trim();
        this.initialDataLoaded = true;
      } else {
        // 如果初始 props 中没有数据，则从 API 获取
        this.fetchData();
      }
    },

    async fetchData() {
      if (!this.file_info || !this.file_info.id) {
        this.error = "文件信息或文件 ID 无效。";
        console.error("fetchData: file_info or file_info.id is missing.");
        this.initialDataLoaded = true; // 标记为已尝试加载
        return;
      }
      const projectFileId = this.file_info.id;

      this.isLoading = true;
      this.error = null;
      this.rawMarkdownResponse = ""; // 清空以便接收新数据
      this.initialDataLoaded = false; // 重置
      if (this.streamCancellation) { // 如果之前有流，确保取消
        this.streamCancellation.cancelStream();
        this.streamCancellation = null;
      }

      try {
        const apiCall = await fetchAnalysisResultApi(
            projectFileId,
            // onJsonReceived
            (jsonData) => {
              let combinedMarkdown = "";
              this.rawMarkdownResponse = jsonData.trim();
              this.isLoading = false;
              this.initialDataLoaded = true;
            },

            // onStreamChunkReceived
            (chunk) => {
              if (chunk.trim() !== "") {
                if (this.isLoading) this.isLoading = false; // 收到第一个有效块后，不再是初始加载状态
                if (!this.initialDataLoaded) this.initialDataLoaded = true;
              }
              this.rawMarkdownResponse += chunk;
            },
            // onStreamEnd
            () => {
              console.log('Vue Component: SSE Stream ended.');
              this.isLoading = false; // 确保流结束后 loading 状态正确
              this.initialDataLoaded = true;
              this.streamCancellation = null; // 流结束，清除取消函数
            },
            // onError
            (err) => {
              console.error('Vue Component: API Error callback:', err);
              this.error = err.message || '获取分析结果失败。';
              this.isLoading = false;
              this.initialDataLoaded = true;
              this.streamCancellation = null; // 出错，清除取消函数
            }
        );

        if (apiCall && typeof apiCall.cancelStream === 'function') {
          this.streamCancellation = apiCall; // 保存取消函数
        } else if (!apiCall && !this.error) { // 如果 apiCall 返回 null 且没有错误被设置
          this.error = 'API调用未能初始化流或返回JSON。';
          this.isLoading = false;
          this.initialDataLoaded = true;
        }

      } catch (err) { // 这个 catch 主要捕获 fetchAnalysisResultApi 本身同步抛出的错误 (如果有的话)
        console.error('Vue Component: fetchData direct catch:', err);
        this.error = err.message || '获取数据时发生意外错误。';
        this.isLoading = false;
        this.initialDataLoaded = true;
      }
    },

    // 组件销毁前调用，以中止任何正在进行的流
    cleanupStream() {
      if (this.streamCancellation) {
        console.log('Vue Component: Cleaning up stream on unmount.');
        this.streamCancellation.cancelStream();
        this.streamCancellation = null;
      }
    }
  },
  watch: {
    // 如果 file_info prop 发生变化，重新获取数据
    file_info: {
      handler(newFileInfo, oldFileInfo) {
        // this.renderInitialMarkdown();
        // if (newFileInfo.file_analyse) {
        //
        // }
      },
      deep: true // 如果 file_info 内部属性也可能变化触发更新
    }
  },
  mounted() {
    // console.log('Component mounted. file_info:', this.file_info);
    this.renderInitialMarkdown();
  },
  beforeUnmount() {
    this.cleanupStream();
  }
};
</script>


<style scoped>
.markdown-display-box {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  background-color: #fff;
}

.markdown-content {
  padding: 10px;
  line-height: 1.6;
  font-size: 0.8em;
}

.loading-indicator, .error-message, .empty-message {
  padding: 10px;
  text-align: center;
}

.error-message {
  color: red;
}

</style>